import React from 'react';

import {TCustomColumn, IUseCustomTableArgs} from 'components/@common/widgets/custom-table/custom-table';

import {TForecastCommentsCore, TFactors} from '../../model/types';
import {ForecastCommentsCommentModal} from '../modal/comment-modal';
import {BASE_COLUMNS} from './table.constants';
import styles from './table.module.less';

/**
 * Создает колонку для отображения данных фактора
 *
 * @param {TForecastCommentsCore[] | undefined} tableData - Данные таблицы
 * @param {number} sectionIndex - Индекс фактора в массиве factors
 *
 * @returns {TCustomColumn<TForecastCommentsCore>} Колонка таблицы с данными фактора
 */
const createFactorColumn = (
    tableData: TForecastCommentsCore[] | undefined,
    sectionIndex: number
): TCustomColumn<TForecastCommentsCore> => {
    const factorName = tableData?.[0]?.factors[sectionIndex]?.factorName;

    return {
        dataIndex: 'factors',
        key: `factors-section-${sectionIndex}`,
        title: factorName,
        children: [
            {
                dataIndex: 'factors',
                key: `factorName-${sectionIndex}`,
                title: 'Прогноз НО',
                width: '100px',
                align: 'center',
                render: (factors: TFactors[]) => factors?.[sectionIndex]?.forecastValueFts,
            },
            {
                dataIndex: 'factors',
                key: `commentTaxpayerPayment-${sectionIndex}`,
                title: 'Комментарий НО',
                width: '200px',
                align: 'center',
                render: (factors: TFactors[]) => (
                    <div className={styles['comment-cell']}>
                        <ForecastCommentsCommentModal
                            comment={factors?.[sectionIndex]?.forecastCommentFts}
                            title="Комментарий НО"
                        />
                    </div>
                ),
            },
            {
                dataIndex: 'factors',
                key: `forecastOrgPayment-${sectionIndex}`,
                title: 'Прогноз НП',
                width: '100px',
                align: 'center',
                render: (factors: TFactors[]) => factors?.[sectionIndex]?.forecastValueOrg,
            },
            {
                dataIndex: 'factors',
                key: `commentOrgPayment-${sectionIndex}`,
                title: 'Комментарий НП',
                width: '200px',
                align: 'center',
                render: (factors: TFactors[]) => (
                    <div className={styles['comment-cell']}>
                        <ForecastCommentsCommentModal
                            comment={factors?.[sectionIndex]?.forecastCommentOrg}
                            title="Комментарий НП"
                        />
                    </div>
                ),
            },
        ],
    };
};

/**
 * Динамически создает колонки таблицы на основе полученных данных
 *
 * @param {TForecastCommentsCore[] | undefined} tableData - Данные таблицы с бэкенда
 *
 * @returns {IUseCustomTableArgs['columns']} Массив колонок для таблицы
 */
export const createDynamicColumns = (
    tableData: TForecastCommentsCore[] | undefined
): IUseCustomTableArgs['columns'] => {
    if (!tableData || tableData.length === 0) {
        return [];
    }

    const maxFactorsCount = tableData[0].factors?.length;

    const factorColumns = [];

    for (let i = 0; i < maxFactorsCount; i += 1) {
        factorColumns.push(createFactorColumn(tableData, i));
    }

    return [...BASE_COLUMNS, ...factorColumns];
};
